module.exports = __webpack_public_path__ + "img/bell-horizon.c6576aef.webp";